import React, { useEffect, useState } from "react";
import LocalstorageService from "../../Service/LocalstorageService";

interface ConfusionMatrixIframeProps {
  src: string;
  height?: string;
  scrolling?: "no" | "yes";
  time?: string
}


const ConfusionMatrixIframe: React.FC<ConfusionMatrixIframeProps> = ({ src, height, scrolling, time }) => {
  const [notFound, setNotFound] = useState(false);
  const [iframeHtml, setIframeHtml] = useState<string>("");
  


  useEffect(() => {
  setNotFound(false);
  setIframeHtml("");
  let url = src;
  if (time) {
    const hasQuery = src.includes("?");
    url = src + (hasQuery ? "&" : "?") + `t=${encodeURIComponent(time)}`;
  }
  const token = LocalstorageService.getLocalAccessToken();
  fetch(url, {
    headers: token ? { Authorization: token } : undefined,
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Report request failed with status ${res.status}`);
      }
      return res.text();
    })
    .then((html) => {
      if (html.includes("Image does not exist")) {
        setNotFound(true);
      } else {
        const css = `
          <style>
            ::-webkit-scrollbar { display: none; }
            body { -ms-overflow-style: none; scrollbar-width: none; }
          </style>
        `;

        let styledHtml;
        if (html.includes("</head>")) {
          styledHtml = html.replace("</head>", css + "</head>");
        } else {
          styledHtml = css + html;
        }

        setIframeHtml(styledHtml);
      }
    })
    .catch((error) => {
      console.error("Unable to load training report", error);
      setNotFound(true);
    });
}, [src, time]);


  if (notFound) {
    // Animated placeholder (skeleton box shimmer)
    return (
      <div
        style={{
          width: "100%",
          height: height || 120,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f5f5",
          borderRadius: 8,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "90%",
            height: "70%",
            background: "#e0e0e0",
            borderRadius: 6,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background:
                "linear-gradient(90deg, #e0e0e0 0%, #f5f5f5 50%, #e0e0e0 100%)",
              animation: "shimmer 1.5s infinite linear",
              opacity: 0.7,
            }}
          />
        </div>
        <style>{`
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}</style>
      </div>
    );
  }

  // Use the same url for iframe key to force re-mount
  let iframeUrl = src;
  if (time) {
    const hasQuery = src.includes("?");
    iframeUrl = src + (hasQuery ? "&" : "?") + `t=${encodeURIComponent(time)}`;
  }
  return (
    <iframe
      key={iframeUrl}
      title="Confusion Matrix"
      style={{ width: "100%", height: height, minHeight: 0, border: "none", display: "block", }}
      sandbox="allow-scripts allow-same-origin"
      scrolling={scrolling}
      id={time}
      srcDoc={iframeHtml}
    />
  );
};

export default ConfusionMatrixIframe;
